import { ScopeButton } from '@monorepo/shared-lib';
import { Col, Form, Row, Spin, Typography } from 'antd';
import Logo from 'assets/images/generateTAX-logo.svg';
import { AuthA11yToggle } from 'components/Auth/AuthA11yToggle';
import { FormInput } from 'components/Custom/inputs';
import { CenterLogo } from 'components/Custom/logo';
import { FormWrapper } from 'components/Custom/wrappers';
import { useAuthA11yMode } from 'hooks/useAuthA11yMode';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import routes from 'routes';

interface ResetPasswordRequestFormProps {
  onRequestResetPassword: (email: string) => void;
  loading?: boolean;
}

interface ResetPasswordRequestFormValues {
  email: string;
}

export const ResetPasswordRequestForm: React.FC<
  ResetPasswordRequestFormProps
> = ({ onRequestResetPassword, loading }) => {
  const { t } = useTranslation();
  const { a11yMode, handleA11yModeChange, authFormClassName } = useAuthA11yMode();

  const handleResendSubmit = async (
    values: ResetPasswordRequestFormValues
  ): Promise<void> => {
    onRequestResetPassword(values.email);
  };
  return (
    <FormWrapper>
      <Spin spinning={loading} style={{ marginTop: '150px' }} size="large">
        <Row justify="center">
          <Link to={routes.login} aria-label={t('login.logo-aria-label')}>
            <CenterLogo src={Logo} alt="" />
          </Link>
        </Row>
        <AuthA11yToggle
          placement="header"
          checked={a11yMode}
          onChange={handleA11yModeChange}
        />
        <div className="divider-20" />
        <Row justify="center" align={'middle'} style={{ textAlign: 'center' }}>
          <Col span={6}>
            <Row justify="start">
              <Col span={24}>
                <Typography.Title
                  level={3}
                  style={{
                    fontWeight: 300,
                  }}
                >
                  {t('forgot-password.page-title')}
                </Typography.Title>
              </Col>
              <div className="divider-20" />
              <Col span={24} style={{ marginTop: '30px' }}>
                <Form
                  layout="vertical"
                  requiredMark={false}
                  className={authFormClassName}
                  onFinish={handleResendSubmit}
                  style={{ marginBottom: '30px' }}
                >
                  <Row gutter={24} justify="space-between">
                    <Col span={24}>
                      <Form.Item
                        name="email"
                        label={t('signup.email-address')}
                        rules={[
                          {
                            required: true,
                            message: t('common.required-field'),
                          },
                          {
                            type: 'email',
                            message: t('signup.invalid-email'),
                          },
                        ]}
                      >
                        <FormInput
                          placeholder={t('signup.email-address')}
                          autoComplete="email"
                        />
                      </Form.Item>
                    </Col>
                    <div className="divider-20" />
                    <div className="divider-20" />
                    <Col span={24}>
                      <Form.Item>
                        <ScopeButton type="primary" htmlType="submit">
                          {t('forgot-password.send-instructions')}
                        </ScopeButton>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Link className="link link-text" to={routes.login}>
                        {t('forgot-password.back-to-login')}
                      </Link>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </FormWrapper>
  );
};
